<div class="p-mt-3">
    <div class="p-text-bold">
        <h4 class="p-text-secondary" style="opacity: 0.7;">Settings</h4>
    </div>
    <div class="card">
        <div class="p-grid width-100 p-ai-center p-mb-3 divider-bottom">

            <div class="p-col-3">
                <h5 class="p-m-0 p-text-primary">Notification Access Control</h5>
            </div>

        </div>

        <div>
            <div class="p-grid width-100 p-ai-center">
                <div class="p-col-12">
                    <notification-access-control></notification-access-control>
                </div>
            </div>
        </div>
    </div>
</div>
